import React, { useState } from 'react';
import { HttpMethod } from '../../Asset/httpMethod';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import Loader from '../Utility/Loader';
import { startLoader, stopLoader } from '../../Redux/Slices/Utility/loaderSlice';
import './Login.css';
import logoImg from '../../Asset/Image/Login/Logo.png';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('');
  const [messageType, setMessageType] = useState('');

  let dispatch = useDispatch();
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      dispatch(startLoader());
      await HttpMethod.post('/Authorization/Account/ForgotPassword', { email });
      setMessageType('success');
      setMsg('Password reset link sent. Check your email.');
    } catch (err) {
      setMessageType('error');
      setMsg(err.response?.data || 'Something went wrong');
    } finally {
      dispatch(stopLoader());
    }
  };

  return (
    <>
      <Loader />
      <div className="login_page">
        <div className="login_overlay" />
        <div className="login_wrapper">
          <div className="login_side">
            <div className="login_side_inner">
              <img src={logoImg} alt="Logo" className="login_side_logo" />
              <p className="login_side_title">Illuminate Your Moments with SUN DIAM Diamonds</p>
            </div>
          </div>
          <div className="login_card">
            <div className="login_card_header">
              <h2>Forgot Password</h2>
              <span className="login_card_subtitle">Enter your email to reset password</span>
            </div>
            <form onSubmit={handleSubmit} className="login_form">
              <div className="mb-3">
                <input
                  type="email"
                  className="form-control login_input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="Enter Email"
                  autoComplete="email"
                />
              </div>
              {msg && (
                <p className={`forgot_message ${messageType === 'success' ? 'success' : 'error'}`}>
                  {msg}
                </p>
              )}
              <button className="login_button btn btn-primary w-100 mb-3" type="submit">
                Send Reset Link
              </button>
              <div className="register_line text-center">
                <span>Remember Password?</span>
                <Link to="/login" className="register_link">
                  Back to Login
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
